import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Car, Mail, Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { useT } from "../i18n";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { t } = useT();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const input = "border border-input bg-background pl-10 pr-3 py-2.5 text-sm rounded-md w-full focus:outline-none focus:ring-2 focus:ring-accent";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="bg-black text-white w-12 h-12 flex items-center justify-center rounded-md mx-auto mb-4"><Car className="h-6 w-6" /></div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{t("auth.login_title")}</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          {error && <div className="bg-destructive/10 text-destructive text-sm rounded-md px-3 py-2" data-testid="login-error">{error}</div>}
          <div className="relative"><Mail className="h-4 w-4 absolute left-3 top-3 text-muted-foreground" />
            <input className={input} type="email" placeholder={t("auth.email")} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" /></div>
          <div className="relative"><Lock className="h-4 w-4 absolute left-3 top-3 text-muted-foreground" />
            <input className={input} type="password" placeholder={t("auth.password")} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" /></div>
          <Button type="submit" className="w-full rounded-md bg-accent hover:bg-accent/90 h-11" disabled={loading} data-testid="login-submit">
            {loading ? t("common.loading") : t("auth.login_btn")}
          </Button>
        </form>
      </div>
    </div>
  );
}
